<template>
  <div>
    <div class="header-img">
      <!-- +'?x-oss-process=image/resize,m_pad,h_180,w_375,color_000000' -->
      <img
        :src="activeInfo.TitleImagePath !=null?activeInfo.TitleImagePath+'?x-oss-process=image/resize,m_pad,h_360,w_750':defaultImg"
        :onerror="defaultImg"
        alt
      >
      <div class="btn-main label">{{activeInfo.ActTypeName}}</div>
    </div>
    <div class="header-title">
      <h5>{{activeInfo.Title}}</h5>
      <span>时间：{{activeInfo.ActivityStartTimeTXT}} 至 {{activeInfo.ActivityEndTimeTXT}}</span>
      <span>地点：{{activeInfo.ProvinceName}}{{activeInfo.CityName}}</span>
    </div>
    <div class="article">
      <h5>活动介绍</h5>
      <article v-html="activeInfo.Content" class="article-content"></article>
    </div>
    <footer-logo></footer-logo>
    <footer class="clearfix">
      <ul class="menu clearfix">
        <li>
          <router-link :to="{path:'/'}">
            <i></i>
            <span>首页</span>
          </router-link>
        </li>
        <collect type="activity" :resource-id="$route.params.id"/>
        <share-button :share-data="returnInfo"/>
      </ul>
      <button
        class="btn-main btn-apply"
        :class="btnSignUpClass"
        @click="onApply()"
        :disabled="btnSignUpDisable"
      >{{btnSignUpText}}      </button>
    </footer>

    <!-- 隐私协议模态框 -->
    <PrivacyAgreementModal
      :visible="showPrivacyModal"
      @agree="handlePrivacyAgree"
      @cancel="handlePrivacyCancel"
    />
  </div>
</template>

<script>
import Constants from '@/js/constants.js'
import ShareButton from '@/components/shareButton.vue'
import Collect from '@/components/collect.vue'
import footerLogo from '@/components/footerLogo.vue'
import PrivacyAgreementModal from '@/components/PrivacyAgreementModal.vue'
import { Slider, SliderItem } from 'vue-ydui/dist/lib.rem/slider'
import { Confirm, Alert, Toast, Notify, Loading } from 'vue-ydui/dist/lib.rem/dialog'
export default {
  name: 'activity-details',
  components: {
    ShareButton,
    Collect,
    SliderItem,
    Slider,
    'footer-logo': footerLogo,
    PrivacyAgreementModal
  },
  data() {
    return {
      hintInner: '展开全部',
      applyStatus: -1,
      isLoadEnd: false,
      isActivityEnd: true,
      endTime: '',
      returnInfo: {
        title: '',
        desc: '',
        link: location.href,
        image: ''
      },
      isShow: false,
      type: 3,
      activeInfo: {},
      activeData: {
        activityId: this.$route.query.id
      },

      ticketId: 0,
      defaultImg:
        'http://image.gongyila.com/org/1/album/2018/09/01d34f33d65440c58d11d1802f3c1cc7.png?x-oss-process=image/resize,m_fill,h_190,w_375',
      // defaultImg: 'this.src="' + require("@/assets/images/defaultImg.png") + '"'
      showPrivacyModal: false
    }
  },
  computed: {
    btnSignUpDisable() {
      if (this.isActivityEnd || !this.isLoadEnd || this.applyStatus == 0 || this.applyStatus == 6) {
        return true
      }
      return false
    },
    btnSignUpClass() {
      var classes = {
        disabled: false
      }
      if (this.isActivityEnd || this.applyStatus == 0 || this.applyStatus == 6) {
        classes['disabled'] = true
      }
      return classes
    },
    btnSignUpText() {
      if (this.isActivityEnd) {
        return '活动结束'
      } else {
        if (this.applyStatus == 0) {
          return '待审核'
        } else if (this.applyStatus == 1) {
          return '我要重新报名'
        } else if (this.applyStatus == 6) {
          return '已通过'
        } else {
          return '我要报名'
        }
      }
    }
  },
  created() {
    var activityId = this.$route.params.id
    if (!activityId) activityId = this.$route.query.id

    this.activeData.activityId = activityId

    var _this = this
    _this.getActInfo()
  },
  methods: {
    onApplyLink() {
      this.$router.push({
        path: '/activity/ticketChange'
      })
    },
    getActInfo() {
      var nowTime = new Date().getTime()
      this.$fetch('/api/Activity/GetActivityDetail', this.activeData).then(result => {
        this.activeInfo = result
        this.applyStatus = this.activeInfo.ApplyStatus
        this.returnInfo.title = result.Title
        this.returnInfo.desc =
          ' 地点:' + result.ProvinceName + result.CityName + '时间：' + result.ActivityStartTimeTXT
        this.returnInfo.image = result.TitleImagePath

        document.title = result.Title

        console.log(location.href, 'location.href')
        this.endTime = this.$convert2Date(result.ActivityEndTime).getTime()
        console.log(this.endTime, 'endTime')
        if (nowTime >= this.endTime) {
          this.isActivityEnd = true
        } else {
          this.isActivityEnd = false
          this.getTicket()
        }
      })
    },
    getTicket() {
      this.$fetch('/api/Activity/GetDefaultTicketId', this.activeData).then(result => {
        this.ticketId = result
        this.isLoadEnd = true
      })
    },
    onApply() {
      if (this.applyStatus == 0 || this.applyStatus == 6) {
        this.$dialog.toast({
          mes: '您已报名！',
          timeout: 1500
        })
        return
      }

      // 只有活动ID为4258时才显示隐私协议模态框
      if (this.activeData.activityId == 4258||this.activeData.activityId == 4294) {
        this.showPrivacyModal = true
      } else {
        // 其他活动直接跳转到报名页面
        this.$router.push({
          path: '/activity/signup/basic',
          query: {
            ActivityId: this.activeData.activityId,
            ticketId: this.ticketId
          }
        })
      }
    },
    handlePrivacyAgree() {
      // 用户同意隐私协议，关闭模态框并跳转到报名页面
      this.showPrivacyModal = false
      this.$router.push({
        path: '/activity/signup/basic',
        query: {
          ActivityId: this.activeData.activityId,
          ticketId: this.ticketId
        }
      })
    },
    handlePrivacyCancel() {
      // 用户取消，关闭模态框
      this.showPrivacyModal = false
    }
  }
}
</script>

<style lang="less">
.header-img {
  width: 100%;
  height: 360 / @rem-size;
  // background: #000;
  line-height: 360 / @rem-size;
  overflow: hidden;
  position: relative;

  .label {
    width: 80 / @rem-size;
    height: 40 / @rem-size;
    font-size: 24 / @rem-size;
    text-align: center;
    line-height: 40 / @rem-size;
    position: absolute;
    top: 16 / @rem-size;
    left: 0;
    margin: auto;
  }
}

.header-title {
  background: #fff;
  padding: 24 / @rem-size;
  border-bottom: 20 / @rem-size solid #f7f7f7;

  h5 {
    font-size: 32 / @rem-size;
    color: #3e3e3e;
    font-weight: 500;
  }

  span {
    display: block;
    font-size: 28 / @rem-size;
    color: #999;
    margin-top: 10 / @rem-size;
  }
}

.article {
  padding: 0 0 20 / @rem-size;
  background: #fff;

  article {
    padding: 24 / @rem-size 24 / @rem-size 0;
  }

  h5 {
    font-size: 32 / @rem-size;
    color: #000033;
    padding-left: 48 / @rem-size;
    line-height: 72 / @rem-size;
    border-bottom: 1px solid #e5e5e5;
    position: relative;

    &::after {
      display: block;
      content: '';
      width: 4 / @rem-size;
      height: 32 / @rem-size;
      background: #005fd5;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 24 / @rem-size;
      margin: auto;
    }
  }
}

footer {
  width: 100%;
  height: 98 / @rem-size;
  background: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  box-shadow: 0 0 18px 0 rgba(208, 208, 208, 0.2);
  z-index: 888;

  .menu {
    width: 390 / @rem-size;
    height: 100%;
    float: left;

    li {
      width: 33.33333%;
      height: 100%;
      float: left;
      padding-top: 10 / @rem-size;

      &:active {
        opacity: 0.8;
      }

      i {
        display: block;
        width: 46 / @rem-size;
        height: 44 / @rem-size;
        margin: 0 auto;
        background-image: url('../../assets/images/activity-icon.png');
        background-size: 184 / @rem-size 44 / @rem-size;

        &.collected {
          background-position: -92 / @rem-size 0 !important;
        }
      }

      &:nth-child(2) {
        i {
          background-position: -46 / @rem-size 0;
        }
      }

      &:nth-child(3) {
        i {
          background-position: -138 / @rem-size 0;
        }
      }

      span {
        display: block;
        font-size: 24 / @rem-size;
        color: #999;
        text-align: center;
        margin-top: 8 / @rem-size;
      }
    }
  }
}

.article-content {
  padding: 20 / @rem-size 24 / @rem-size 0;
}

.btn-apply {
  width: 360 / @rem-size;
  height: 100%;
  float: left;
  font-size: 36 / @rem-size;
  box-shadow: unset;
}
</style>
